interface BottomStatusBarProps {
  cursorCoordinate: [number, number] | null;
  featureCount: number;
  message: string | null;
}

export default function BottomStatusBar({ cursorCoordinate, featureCount, message }: BottomStatusBarProps) {
  return (
    <div className="flex items-center justify-between px-3 py-1.5 border-t border-background-200/70 bg-white text-[11px] text-foreground-500">
      <span>
        {cursorCoordinate ? `Lon ${cursorCoordinate[0].toFixed(6)}, Lat ${cursorCoordinate[1].toFixed(6)}` : "Mova o cursor sobre o mapa"}
      </span>
      <span className="flex-1 text-center truncate px-2">{message ?? ""}</span>
      <span>{featureCount} feição(ões) carregada(s)</span>
    </div>
  );
}
